import api from "../../../services/api";

export interface ChannelPerformanceRaw {
  channel: string;
  shopify_revenue?: number;
  shopify_order_count?: number;
  shopify_units_sold?: number;
  wholesale_revenue?: number;
  wholesale_order_count?: number;
  wholesale_units_sold?: number;
  average_order_value: number;
}

export interface CategoryPerformance {
  category: string;
  units_sold: number;
  average_price: number;
  revenue: number;
  average_order: number;
}

export interface ColorPerformance {
  color: string;
  color_description: string;
  units_sold: number;
  revenue: number;
  average_order: number;
}

export interface GenderPerformance {
  category: string;
  units_sold: number;
  revenue: number;
}

export interface CollectionPerformance {
  merch_collection_code: string;
  merch_collection_description: string;
  units_sold: number;
  revenue: number;
  average_order: number;
}

export interface ClassPerformance {
  class: string;
  class_description: string;
  units_sold: number;
  revenue: number;
  average_order: number;
}

export interface CompletePerformance {
  style: string,
  product_name: string,
  color: string,
  color_description: string,
  class: string,
  gender: string,
  category: string,
  merch_collection_description: string,
  units_sold: number,
  revenue: number,
  average_order: number
}

export interface StyleColorPerformance {
  style_color: string,
  style: string,
  color: string,
  style_description: string,
  color_description: string,
  units_sold: number,
  revenue: number,
  average_order: number
}

export interface WholesaleSalesRawResponse {
  start_date: string;
  end_date: string;
  prev_start_date: string;
  prev_end_date: string;
  total_revenue: number;
  total_orders: number;
  total_units_sold: number;
  average_order_value: number;
  prev_total_revenue: number;
  prev_total_orders: number;
  prev_total_units_sold: number;
  prev_average_order_value: number;
  revenue_growth: number;
  order_growth: number;
  units_growth: number;
  average_order_growth: number;
  channel_performance: ChannelPerformanceRaw[];
  shopify_category_performance: CategoryPerformance[];
  wholesale_category_performance: CategoryPerformance[];
  wholesale_color_performance: ColorPerformance[];
  wholesale_gender_performance: GenderPerformance[];
  wholesale_collection_performance: CollectionPerformance[];
  wholesale_class_performance: ClassPerformance[];
  wholesale_complete_performance: CompletePerformance[];
  wholesale_style_color_performance: StyleColorPerformance[];
}

export const fetchWholesaleSales = async (
  start_date: string,
  end_date: string
): Promise<WholesaleSalesRawResponse> => {
  const response = await api.get("/api/wholesale/sales_reports/dashboard", {
    params: { start_date, end_date },
  });
  return response.data;
};
